export default __webpack_public_path__ + "static/media/youtube.5166fa54.svg";